import axios from 'axios'

import PATHS from 'src/common/constants/paths'

export const BASE_URL = process.env.REACT_APP_BASE_URL
export const BASE_URL_CLIENT_API = process.env.REACT_APP_BASE_URL_CLIENT_API

const ACCESS_TOKEN_KEY = 'accessToken'

export function axiosClient() {
    let defaultOptions = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY) || sessionStorage.getItem(ACCESS_TOKEN_KEY)}`,
        },
    }

    let instance = axios.create(defaultOptions)

    instance.interceptors.request.use(function (config) {
        config.headers.common = {
            Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY) || sessionStorage.getItem(ACCESS_TOKEN_KEY)}`,
        }
        return config
    })
    instance.interceptors.response.use(
        function (response) {
            if (!navigator.onLine) {
                // Navigate to the no connection page
                window.location.href = PATHS.NO_CONNECTION
                return Promise.reject(new Error('User is offline'))
            }
            return response
        },
        function (error) {
            if (error.response && error.response.status === 502) {
                // Navigate to the maintenance page
                window.location.href = PATHS.MAINTENANCE
            }
            if (error.response && error.response.status === 403) {
                // Clear auth tokens and redirect to login
                localStorage.removeItem(ACCESS_TOKEN_KEY)
                sessionStorage.removeItem(ACCESS_TOKEN_KEY)
                window.location.href = PATHS.AUTHENTICATION.LOGIN
            }
            if (!navigator.onLine) {
                // Navigate to the no connection page
                window.location.href = PATHS.NO_CONNECTION
            }
            return Promise.reject(error)
        }
    )

    return instance
}

export const clientAdminAxios = axios.create({
    baseURL: BASE_URL_CLIENT_API,
    headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY) || sessionStorage.getItem(ACCESS_TOKEN_KEY)}`,
        'Content-Type': 'application/json',
    },
})

export default axiosClient
